import { baseApi } from "./baseApi";

const CUSTOMER_BASE_URL = "/customers";

export const customerApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    AddCustomer: builder.mutation({
      query: (payLoad) => ({
        url: CUSTOMER_BASE_URL,
        method: "POST",
        body: payLoad,
      }),
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "Customer", id: _id },
        { type: "Customer", id: "LIST" },
      ],
    }),

    listCustomer: builder.query({
      query: (params) => ({
        url: `${CUSTOMER_BASE_URL}`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({ type: "Customer", _id })),
            { type: "Customer", id: "LIST" },
          ]
          : [{ type: "Customer", id: "LIST" }],
    }),

    listCustomerWithMinimalData: builder.query({
      query: (params) => ({
        url: `${CUSTOMER_BASE_URL}/listCustomerWithMinimalData`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({ type: "Customer", _id })),
            { type: "Customer", id: "LIST" },
          ]
          : [{ type: "Customer", id: "LIST" }],
    }),

    getDDLCustomer: builder.query({
      query: (params) => ({ url: `${CUSTOMER_BASE_URL}/ddl`, params }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({ type: "Customer", _id })),
            { type: "Customer", id: "DDL" },
          ]
          : [{ type: "Customer", id: "DDL" }],
    }),

    getCustomerDetail: builder.query({
      query: (customerId) => `${CUSTOMER_BASE_URL}/${customerId}`,
      providesTags: (_result, _error, { _id }) => [
        { type: "Customer", _id },
        { type: "Customer", id: "LIST" },
      ],
    }),

    updateCustomer: builder.mutation({
      query: ({ _id, ...body }) => ({
        url: `${CUSTOMER_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { _id: id }) => [
        { type: "Customer", id },
        { type: "Customer", id: "LIST" },
      ],
    }),

    getCustomerProfileByUserId: builder.query({
      query: (userId) => `${CUSTOMER_BASE_URL}/user/${userId}`,
      providesTags: (result, error, userId) => [
        { type: "CustomerProfile", id: userId },
        { type: "CustomerProfile", id: "LIST" },
      ],
    }),

    // add Customer Notes
    addCustomerNotes: builder.mutation({
      query: (payload) => {
        const { customerId, ...body } = payload;

        return {
          url: `${CUSTOMER_BASE_URL}/${customerId}/notes`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "Customer", id: _id },
        { type: "Customer", id: "LIST" },
      ],
    }),

    // Update Customer Note
    updateCustomerNotesV: builder.mutation({
      query: ({ customerId, noteId, ...body }) => ({
        url: `${CUSTOMER_BASE_URL}/${customerId}/notes/${noteId}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "Customer", id: _id },
        { type: "Customer", id: "LIST" },
      ],
    }),

    // New query to fetch notes by customerId
    listCustomerNotes: builder.query({
      query: ({ customerId, page, limit }) => ({
        url: `${CUSTOMER_BASE_URL}/${customerId}/notes`,
        params: { page, limit },
      }),
      providesTags: (_result, _error, { _id }) => [
        { type: "Customer", id: _id },
        { type: "Customer", id: "LIST" },
      ],
    }),

    listCustomerShipments: builder.query({
      query: ({ customerId, page, limit }) => ({
        url: `${CUSTOMER_BASE_URL}/${customerId}/shipments`,
        params: { page, limit },
      }),
      providesTags: (_result, _error, { _id }) => [
        { type: "Customer", id: _id },
        { type: "Customer", id: "LIST" },
      ],
    }),

    // Add Customer Profile API
    AddCustomerProfile: builder.mutation({
      query: (payLoad) => ({
        url: `${CUSTOMER_BASE_URL}/profile`,
        method: "POST",
        body: payLoad,
      }),
      invalidatesTags: [{ type: "Customer", id: "LIST" }],
    }),
    searchCustomers: builder.query({
      query: ({ account, entity, query }) => ({
        url: `${CUSTOMER_BASE_URL}/search`,
        params: { account, entity, query },
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result?.data?.map(({ _id }) => ({ type: "Customer", _id })),
            { type: "Customer", id: "SEARCH" },
          ]
          : [{ type: "Customer", id: "SEARCH" }],
    }),
  }),
});

export const {
  useAddCustomerMutation,
  useAddCustomerProfileMutation,
  useListCustomerQuery,
  useGetCustomerProfileByUserIdQuery,

  useLazyListCustomerQuery,
  useLazyListCustomerWithMinimalDataQuery,
  useLazyGetDDLCustomerQuery,
  useGetCustomerDetailQuery,
  useUpdateCustomerMutation,
  useAddCustomerNotesMutation,
  useUpdateCustomerNotesVMutation,
  useLazyListCustomerNotesQuery,
  useDeleteCustomerNoteMutation,
  useLazyListCustomerShipmentsQuery,
  //search
  useLazySearchCustomersQuery,
} = customerApi;
